import Project from "../../../classes/Project";
import { db } from "../../../boot/firebase";
import { call } from "../../../util/misc";
import { deleteDoc, doc, setDoc, updateDoc } from "firebase/firestore";

export const GET_PROJECT = ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: Project,
    path: Project.getPath(id),
    stateKey: "projects",
    id,
  });
};

export const GET_PROJECTS = (
  { dispatch },
  { conditions, limitCount, pagination }
) => {
  return dispatch("GET_COLLECTION", {
    converter: Project,
    stateKey: "projects",
    path: Project.getPath(),
    conditions,
    limitCount,
    pagination,
  });
};

export const LISTEN_PROJECT = ({ dispatch }, { id, next, error, unlisten }) => {
  return dispatch("LISTEN_DOC", {
    converter: Project,
    path: Project.getPath(id),
    stateKey: "projects",
    id,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_PROJECTS = (
  { dispatch },
  { pagination, filter, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: Project,
    path: Project.getPath(),
    stateKey: "projects",
    conditions:
      filter === undefined ? null : ["archived", "==", filter === "archive"],
    pagination,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_CONTACT_PROJECTS = (
  { dispatch },
  { contactID, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: Project,
    path: Project.getPath(),
    listenerPath: "projects-" + contactID,
    stateKey: "projects",
    conditions: ["soldTo.contact", "==", contactID],
    pagination: {
      sortBy: "soldDate",
      descending: true,
    },
    next,
    error,
    unlisten,
  });
};

export const CREATE_PROJECT = async (context, project) => {
  return call("createProject", project);
};

export const SAVE_PROJECT = async ({ commit, state }, project) => {
  if (!project.id) {
    // Create
    throw "Use CREATE_PROJECT to create a new project";
  } else {
    // Update
    project.data.modified = new Date();
    project.data.modifiedBy = state.user.id;
    await setDoc(doc(db, project.path).withConverter(Project), project);
    return project;
  }
};

export const UPDATE_PROJECT = ({ state }, { id, changes }) => {
  changes.modified = new Date();
  changes.modifiedBy = state.user.id;
  return updateDoc(doc(db, Project.getPath(id)), changes);
};

export const DELETE_PROJECT = async ({ commit }, id) => {
  await deleteDoc(doc(db, Project.getPath(id)));
  commit("REMOVE", { stateKey: "projects", id });
};
